<template>
  <div class="container">
    <!-- 标题 -->
    <div class="title">{{ $t('share').title }}</div>
    <div class="tinfo">
      <div class="commissionInfo">
        <div class="txt">{{ $t('share').commission }}</div>
        <div class="num">${{ userInfo.commissionAmount.toFixed(2).replace(/\.?0+$/, '') }} <span
            @click="$router.push({ name: 'Invite' })">{{ $t('share').Invitefriends }}</span></div>
      </div>
      <div class="info">
        <!-- 佣金记录 -->
        <div class="item" @click="$router.push({ name: 'CommissionList' })">
          <div class="left">
            <svg-icon class-name="svgs" icon-class="bill" />
            <div class="txt">{{ $t('share').Commissionrecord }}</div>
          </div>
          <van-icon name="arrow" size="25" color="var(--ntext_color)" />
        </div>
        <!-- 转出 -->
        <div class="item" @click="$router.push({ name: 'RollOut' })">
          <div class="left">
            <svg-icon class-name="svgs" icon-class="transfer" />
            <div class="txt">{{ $t('share').Commissiontransferout }}</div>
          </div>
          <van-icon name="arrow" size="25" color="var(--ntext_color)" />
        </div>
        <!-- 转出记录 -->
        <div class="item" @click="$router.push({ name: 'RollOutList' })">
          <div class="left">
            <svg-icon class-name="svgs" icon-class="position" />
            <div class="txt">{{ $t('share').Transferoutrecord }}</div>
          </div>
          <van-icon name="arrow" size="25" color="var(--ntext_color)" />
        </div>
        <!-- 邀请记录 -->
        <div class="item" @click="$router.push({ name: 'InviteList' })">
          <div class="left">
            <svg-icon class-name="svgs" icon-class="share" />
            <div class="txt">{{ $t('share').Invitationrecord }}</div>
          </div>
          <van-icon name="arrow" size="25" color="var(--ntext_color)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      userInfo: { commissionAmount: 0 },
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .tinfo {
    margin: 0 auto;
    max-width: 780px;

    .commissionInfo {
      padding: 30px;
      border-radius: 15px;
      margin: 30px 0;
      background: var(--info_color);

      .txt {
        font-size: 14px;
        color: var(--text_color);
      }

      .num {
        margin-top: 20px;
        font-weight: bold;
        font-size: 32px;
        color: var(--text_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          padding: 15px 30px;
          font-size: 15px;
          background: var(--text_color);
          color: var(--background_color);
          border-radius: 15px;
        }

        span:hover {
          opacity: 0.8;
        }
      }
    }

    .info {
      .item {
        margin-top: 20px;
        border: 2px solid var(--info_color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 30px;
        border-radius: 15px;

        .left {
          display: flex;
          align-items: center;

          .svgs {
            width: 35px;
            height: 35px;
            color: var(--text_color);
            margin-right: 15px;
          }

          .txt {
            font-size: 18px;
            color: var(--text_color);
          }
        }
      }

      .item:hover {
        background: var(--info_color);
      }
    }
  }
}
</style>
